<template>
    <div>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="机构名称" prop='mc'>
                    <el-input v-model="searchForm.mc" placeholder=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetSearch('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
            <el-button type="primary" @click="del()" :disabled="multipleSelection.length==0">删除</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="jgmc" label="机构名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column  label="操作" width="120" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog :title='lx+"归属机构"' :visible.sync="dialogVisible" width='700px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref='form' label-width="80px" :rules="formRules">
                <el-form-item label="名称" prop='jgmc'>
                    <el-input v-model="form.jgmc"></el-input>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                mc:'',
            },
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            lx:'新增',
            form:{

            },
            formRules:{
                jgmc:[{required:true,message:'必填项',trigger:'blur'}],
            },
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getGsjg(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list;
                    this.total=res.data.data.total
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //重置
        resetSearch(formName) {
            this.$refs[formName].resetFields();
        },
        //新增
        add(){
            this.dialogVisible=true;
            this.lx='新增';
            this.form={
                jgmc:'',
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.lx='编辑';
            this.form=Object.assign({},row);
        },
        saveForm(formName){
             this.$refs[formName].validate((valid)=>{
                if(valid){
                    let para=this.form;
                    para.lx=this.adminLx
                    this.$api.saveGsjg(para).then(res=>{
                        if(res.data.meta.success){
                            this.$message({
                                type:'success',
                                message:'保存成功！'
                            })
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message({
                                type:'error',
                                message:res.data.meta.message
                            })
                        }
                    }).catch(()=>{})
                }else{
                    return false;
                }
            })
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false;
        },
        //删除
        del(row){
            let text=''
            let para={
                lx:this.adminLx
            }
            if(row){
                text='确定要删除当前的归属机构吗？'
                para.id=row.id
            }else{
                text='确定要删除选中的归属机构吗？';
                let ids=''
                this.multipleSelection.forEach(item=>{
                    ids+=item.id+','
                })
                para.id=ids.slice(0,ids.length-1)
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delGsjg(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'删除成功！'
                        })
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });
        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
        handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    },
    mounted(){
        this.getData();
    }
}
</script>  